import { FRACTIONAL_UNITS } from "@/features/units/schema";

export function formatAmount(amount, unit) {
  if (unit === 'to taste') return 'To taste';
  if (amount === 0) return '0';

  const integerPart = Math.floor(amount);
  const decimalPart = amount - integerPart;
  
  if (decimalPart === 0) {
    return integerPart.toString();
  }

  if (!FRACTIONAL_UNITS.includes(unit)) {
    return amount.toFixed(1);
  }
  
  const fraction = decimalToFraction(decimalPart);
  if (fraction) {
    return integerPart > 0 ? `${integerPart} ${fraction}` : fraction;
  }
  
  return amount.toFixed(1);
}

export function decimalToFraction(decimal) {
  const tolerance = 0.01;
  const maxDenominator = 12;
  
  for (let denominator = 1; denominator <= maxDenominator; denominator++) {
    for (let numerator = 1; numerator < denominator; numerator++) {
      const fraction = numerator / denominator;
      if (Math.abs(decimal - fraction) < tolerance) {
        return `${numerator}/${denominator}`;
      }
    }
  }
  
  return null;
}

export function formatUnit(unit) {
  if (unit === 'to taste') return '';
  if (unit === 'none') return '';
  return unit;
}
